const pressCarousel = (Swiper, Navigation, Thumbs, EffectFade, Autoplay) => {
	
	const pressCarousel = document.querySelectorAll('.comp__press-carousel');
	const pressThumbs = document.querySelector('.press-gallery-thumbs.swiper');
	const pressTop = document.querySelector('.press-gallery-top.swiper');
	
	if (pressCarousel.length > 0 && pressThumbs && pressTop) {
		
		const thumbsSwiper = new Swiper(pressThumbs, {
			modules: [Thumbs],
			speed: 0,
			slidesPerView: 5,
			spaceBetween: 0,
			watchSlidesProgress: true,
			clickable: true,
			preventInteractionOnTransition: false,
		});
		
		const topSwiper = new Swiper(pressTop, {
			modules: [Navigation, Thumbs, EffectFade, Autoplay],
			loop: true,
			speed: 300,
			spaceBetween: 0,
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true
			},
			navigation: {
				nextEl: '.press-button-next',
				prevEl: '.press-button-prev',
			},
			thumbs: {
				swiper: thumbsSwiper,
				slideThumbActiveClass: 'swiper-slide-thumb-active'
			}
		});
		
	}
		
}

export {
	pressCarousel
};